import React from 'react';
import css from './Hero.module.css';
import hero_img from '../../assets/hero_img.png';
import hero_line from '../../assets/hero_line.png';
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-scroll';

const Hero = () => {
  const navigate = useNavigate();

  return (
    <div className={css.hero}>
      <div className={css.content}>
        <p className={css.eyebrow}>IITian-led mentorship for serious aspirants</p>
        <h1 className={css.heading}>
          Welcome to
          <span className={css.colored}>
            AbhyaasIIT <img src={hero_line} alt='Line' className={css.line} />
          </span>
        </h1>
        <p className={css.para}>
          AbhyaasIIT is an IITian-only initiative for IIT JEE and NEET exam
          preparation in Motihari, with branches in Raghunathpur and Raja
          Bazar. We support students from classes 6th to 12th with structured
          coaching, rigorous practice, and direct personal mentorship.
        </p>
        <p className={css.paraSecondary}>
          Every student receives a personal IITian mentor who stays in constant
          touch with both student and parents to build consistency,
          accountability, and long-term academic growth.
        </p>
        <div className={css.actions}>
          <button
            type='button'
            className={css.primaryBtn}
            onClick={() => navigate('/form')}
          >
            Apply Now
          </button>
          <Link
            to='about-us'
            smooth={true}
            offset={-100}
            duration={500}
            className={css.secondaryBtn}
          >
            Explore Programs
          </Link>
        </div>
        <div className={css.stats}>
          <div className={css.statCard}>
            <strong>14+</strong>
            <span>IITian mentors</span>
          </div>
          <div className={css.statCard}>
            <strong>6th-12th</strong>
            <span>long-term academic support</span>
          </div>
          <div className={css.statCard}>
            <strong>1:1</strong>
            <span>personal mentorship track</span>
          </div>
        </div>
      </div>
      <div className={css.visualWrap}>
        <img src={hero_img} alt='hero_img' className={css.hero_img} />
      </div>
    </div>
  );
};

export default Hero;
